import{transparentize as Io}from"polished";var a=(e,t)=>Io(1-e,t);var o={transparent:"transparent",black:"rgb(0, 0, 0)",white:"rgb(255, 255, 255)",blue:{50:"rgb(225, 246, 254)",100:"rgb(180, 230, 254)",200:"rgb(131, 214, 253)",300:"rgb(79, 199, 251)",400:"rgb(40, 186, 251)",500:"rgb(0, 174, 249)",600:"rgb(0, 159, 234)",700:"rgb(0, 140, 214)",800:"rgb(0, 123, 194)",850:"rgb(0, 113, 178)",900:"rgb(1, 102, 160)",950:"rgb(1, 57, 102)",1e3:"rgb(0, 36, 64)"},grey:{50:"rgb(250, 250, 250)",100:"rgb(245, 245, 245)",200:"rgb(238, 238, 238)",300:"rgb(224, 224, 224)",400:"rgb(189, 189, 189)",500:"rgb(158, 158, 158)",600:"rgb(117, 117, 117)",700:"rgb(97, 97, 97)",800:"rgb(66, 66, 66)",900:"rgb(38, 38, 38)",1e3:"rgb(20, 20, 20)"},red:{50:"rgb(247, 209, 209)",100:"rgb(244, 186, 186)",200:"rgb(240, 163, 163)",300:"rgb(232, 117, 117)",350:"rgb(228, 94, 94)",400:"rgb(225, 71, 71)",500:"rgb(217, 25, 25)",600:"rgb(195, 23, 23)",700:"rgb(174, 20, 20)",800:"rgb(152, 18, 18)",900:"rgb(130, 15, 15)",1e3:"rgb(109, 13, 13)",1100:"rgb(87, 10, 10)"},purple:{500:"rgb(197, 138, 249)",800:"rgb(104, 29, 168)"}};function De(e,t){return Array.isArray(e)&&e.length===2?e[t]:Object.entries(e).reduce((n,[c,i])=>(n[c]=De(i,t),n),{})}function Ie(e,t){return Object.entries(e).reduce((n,[c,i])=>(n[c]=De(i,t),n),{})}var Ae={background:[o.grey[50],o.grey[1e3]],onBackground:[o.grey[900],o.white],onBackgroundSecondary:[o.grey[700],o.grey[300]],icon:[o.grey[500],o.grey[500]],actionIcon:[o.grey[900],o.grey[200]],primary:[o.blue[800],o.blue[400]],content:{onDark:[o.white,o.white],onPrimary:[o.white,o.white],onNeutral:[o.grey[800],o.grey[200]],disabled:[o.grey[300],o.grey[800]],disabledOnPrimary:[o.blue[100],o.blue[900]],disabledOnNeutral:[o.grey[300],o.grey[800]],disabledOnDestructive:[o.red[100],o.red[100]]},surface:{default:[o.white,o.grey[900]],destructive:{default:[o.red[500],o.red[500]],disabled:[o.red[50],o.red[50]],hover:[o.red[600],o.red[600]],active:[o.red[700],o.red[700]]},primary:{default:[o.blue[800],o.blue[800]],disabled:[o.blue[50],o.blue[50]],hover:[o.blue[850],o.blue[700]],active:[o.blue[900],o.blue[600]]},neutral:{default:[o.grey[200],o.grey[800]],disabled:[o.grey[100],o.grey[900]],hover:[o.grey[300],o.grey[700]],active:[o.grey[400],o.grey[600]]},transparent:{default:[o.transparent,o.transparent],hover:{neutralOnLight:[a(.05,o.black),a(.1,o.white)],neutralOnDark:[a(.1,o.white),a(.1,o.white)],primary:[a(.1,o.blue[800]),a(.1,o.blue[400])]},active:{neutralOnLight:[a(.1,o.black),a(.2,o.white)],neutralOnDark:[a(.2,o.white),a(.2,o.white)],primary:[a(.2,o.blue[800]),a(.2,o.blue[400])]}}},outline:{light:[o.grey[300],o.grey[800]],mid:[o.grey[500],o.grey[600]],dark:[o.grey[700],o.grey[400]],focus:[o.blue[900],o.blue[300]]},shadow:{element:[a(.3,o.black),a(.3,o.black)],menu:[a(.25,o.black),a(.25,o.black)]},components:{backdrop:[a(.75,o.black),a(.5,o.white)],badge:{background:[o.white,o.grey[900]],backgroundActive:[a(.1,o.black),a(.2,o.white)],backgroundHover:[a(.05,o.black),a(.1,o.white)],backgroundPressed:[o.blue[50],o.blue[1e3]],text:[o.grey[700],o.grey[200]],icon:[o.grey[500],o.grey[500]],deleteIcon:[o.grey[700],o.grey[200]]},checkbox:{icon:[o.blue[800],o.blue[600]]},menu:{mainBackground:[o.white,o.grey[1e3]],toolbarBackground:[a(.95,o.grey[50]),a(.9,o.grey[1e3])]},note:[o.grey[500],o.grey[500]],label:{active:[o.blue[400],o.blue[800]],hover:[o.blue[600],o.blue[700]]},link:{hover:[o.blue[900],o.blue[300]],active:[o.blue[950],o.blue[200]],visited:[o.purple[800],o.purple[500]]},toggle:{track:{unchecked:[o.grey[500],o.grey[500]],checked:[o.blue[600],o.blue[600]],disabledUnchecked:[o.grey[200],o.grey[200]],disabledChecked:[o.blue[50],o.blue[50]],hoverUnchecked:[o.grey[400],o.grey[400]],hoverChecked:[o.blue[400],o.blue[400]]},thumb:{unchecked:[o.grey[300],o.grey[300]],checked:[o.blue[800],o.blue[800]],disabledUnchecked:[o.grey[100],o.grey[100]],disabledChecked:[o.blue[50],o.blue[50]],hoverUnchecked:[o.grey[200],o.grey[200]],hoverChecked:[o.blue[600],o.blue[600]]}},embeddedBtn:{onBackground:[o.grey[700],o.grey[200]],onBackgroundOnDarkSurface:[o.grey[200],o.grey[200]],backgroundHovered:[a(.05,o.black),a(.1,o.white)],backgroundHoveredOnDarkSurface:[a(.1,o.white),a(.1,o.white)],backgroundPressed:[a(.1,o.black),a(.2,o.white)],backgroundPressedOnDarkSurface:[a(.2,o.white),a(.2,o.white)]}}},Ao=Ie(Ae,0),Or=Ie(Ae,1);import F from"styled-components";import*as w from"@radix-ui/react-accordion";import"react";import{jsx as Me}from"react/jsx-runtime";var Mo=e=>Me("svg",{xmlns:"http://www.w3.org/2000/svg",width:e?.width??24,height:e?.height??24,fill:e?.color??"#424242",viewBox:"0 0 24 24",...e,children:Me("path",{fill:e?.color??"#424242",d:"M12 15.97c-.133 0-.258-.02-.375-.063a.876.876 0 0 1-.325-.212l-4.6-4.6a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l3.9 3.9 3.9-3.9a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7l-4.6 4.6c-.1.1-.208.17-.325.212a1.106 1.106 0 0 1-.375.063"})}),Ee=Mo;import A,{css as R}from"styled-components";var r={25:"0.25rem",50:"0.5rem",75:"0.75rem",100:"1rem",150:"1.5rem",200:"2rem",250:"2.5rem",300:"3rem",350:"3.5rem",400:"4rem"},d={small:"0.25rem",medium:"0.5rem",large:"1rem",round:"99px"},s={innerGap:r[50],componentInlinePadding:r[75],horizontalComponentGap:r[100]},b={xSmall:r[150],small:r[200],medium:r[250],large:r[300],xLarge:r[350]};var de=R`
    font-size: 1rem;
`,p=R`
    line-height: 1em;

    font-size: 1rem;
`,Oe=R`
    font-size: 0.75rem;
`,We=R`
    font-size: 0.875rem;
`,se=R`
    color: ${({theme:e})=>e.onBackground};
`,le=R`
    margin: 0;
`,pe=R`
    /* reset */
    ${le}

    /* content */
    ${se}
    ${de}
`,Eo=A.h2`
    /* reset */
    ${le}
    font-weight: 400;

    /* content */
    ${se}
    font-size: 1.375rem;
`,Oo=A.h3`
    /* reset */
    ${le}

    /* content */
    ${se}
    font-weight: 700;
    font-size: 1.125rem;
`,Wo=A.p`
    ${pe}
`,zo=A.strong`
    font-weight: 700;
`,Lo=A.a`
    /* reset */
    cursor: pointer;

    /* content */
    color: ${({theme:e})=>e.primary};
    text-decoration: underline;
    text-underline-offset: ${r[25]};

    &:hover {
        color: ${({theme:e})=>e.components.link.hover};
    }

    &:active {
        color: ${({theme:e})=>e.components.link.active};
    }

    &:visited {
        color: ${({theme:e})=>e.components.link.visited};
    }
`,Go=A.hr`
    border: none;
    border-top: 1px solid ${({theme:e})=>e.outline.light};
`,M={Divider:Go,SectionHeader:Eo,Subheader:Oo,Paragraph:Wo,Bold:zo,Link:Lo};import{forwardRef as No}from"react";import{mergeProps as Ho,useButton as Uo,useFocusRing as Fo,useHover as Vo}from"react-aria";import Ko,{css as H}from"styled-components";var $={small:"600px",medium:"900px",large:"1200px"};import{jsx as Xo}from"react/jsx-runtime";var h=H`
    all: unset;
    cursor: pointer;
    user-select: none;
    transition:
        background-color 0.3s,
        color 0.3s;
    box-sizing: border-box;
`,P=H`
    width: fit-content;
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
    justify-content: center;
`,L=H`
    border-radius: ${d.small};
    border-width: 1px;
    border-style: solid;
`,U=H`
    @media (max-width: ${$.small}) {
        /* layout */
        width: 100%;
    }
`,ze=No(function(t,n){let{onPress:c,...i}=t,{buttonProps:l,isPressed:k}=Uo({onPress:c},n),{focusProps:u,isFocused:x,isFocusVisible:B}=Fo(t),{hoverProps:ie,isHovered:I}=Vo(t);return Xo("button",{...Ho(i,l,u,ie),"data-disabled":t.isDisabled||void 0,"data-pressed":k||void 0,"data-hovered":I||void 0,"data-focused":x||void 0,"data-focus-visible":B||void 0,ref:n,children:t.children})});ze.displayName="ReactAriaButton";function E(e){switch(e){case"large":return b.large;case"medium":return b.medium;case"small":return b.small}}var m=Ko(ze)`
    /* reset */
    ${h}

    /* layout */
    ${P}

    /* content */
    ${p}

    /* appearance */
    ${L}

    &[data-disabled] {
        cursor: not-allowed;
    }
    &[data-focus-visible] {
        outline: ${({theme:e})=>e.outline.focus} solid 1px;
    }

    height: ${({$variant:e})=>E(e)};
    width: ${({$fluid:e})=>e?"100%":"fit-content"};
`;import{jsx as G,jsxs as Le}from"react/jsx-runtime";var qo=F(w.Trigger)`
    /* reset */
    ${h}

    /* layout */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ${b.small};
    padding-bottom: ${r[25]};
    padding-inline: ${s.componentInlinePadding};

    /* appearance */
    border-radius: ${d.small};

    .expand-icon {
        transition: transform 0.3s;
    }

    &[data-state='open'] {
        .expand-icon {
            transform: rotate(180deg);
        }
    }

    &:hover {
        background-color: ${({theme:e})=>e.surface.transparent.hover.neutralOnLight};
    }

    &:active {
        background-color: ${({theme:e})=>e.surface.transparent.active.neutralOnLight};
    }
`,Jo=F(M.Divider)`
    margin-inline: ${s.componentInlinePadding};
    margin-block: ${r[25]} ${r[50]};
`,Qo=F(w.Root)`
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
`,Yo=({children:e,...t})=>Le(qo,{...t,children:[G(M.SectionHeader,{children:e}),G(Ee,{className:"expand-icon","aria-hidden":!0})]}),Zo=F(w.Content)`
    /* reset content */
    ${pe}

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    flex-direction: column;
    gap: 1rem;
`,_o=({title:e,children:t,...n})=>Le(w.AccordionItem,{value:e,...n,children:[G(Yo,{children:e}),G(Jo,{}),G(Zo,{children:t})]});import*as V from"@radix-ui/react-toggle-group";import*as K from"@radix-ui/react-toggle";import N,{css as He}from"styled-components";import"react";import{jsx as Ge}from"react/jsx-runtime";var jo=e=>Ge("svg",{xmlns:"http://www.w3.org/2000/svg",width:e?.width??24,height:e?.height??24,fill:e?.color??"#424242",viewBox:"0 0 24 24",...e,children:Ge("path",{fill:e?.color??"#424242",d:"m12 13.4-4.9 4.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275l4.9 4.9 4.9-4.9a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L13.4 12l4.9 4.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.949.949 0 0 1-.7-.275z"})}),T=jo;import{jsx as O,jsxs as Ne}from"react/jsx-runtime";var Ue=He`
    /* reset */
    ${h}

    /* layout */
    ${P}
    margin: 0;
    height: ${b.medium};
    gap: ${r[50]};

    /* content */
    color: ${({theme:e})=>e.components.badge.text};

    /* appearance */
    ${L}
    background-color: ${({theme:e})=>e.components.badge.background};
    border-radius: ${d.round};

    svg {
        margin: -${r[25]};
        fill: ${({theme:e})=>e.components.badge.icon};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.outline.focus} solid 2px;
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.content.disabled};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.content.disabled};
        }
    }
`,et=N(V.Root)`
    /* layout */
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
`,me=N(K.Root)`
    ${Ue}

    /* layout */
    padding-inline: ${r[100]};

    /* appearance */
    border-color: ${({theme:e})=>e.outline.light};

    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.components.badge.backgroundHover};
    }

    &&&:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.components.badge.backgroundActive};
    }

    svg.context-icon {
        fill: ${({theme:e,$defaultIconColor:t})=>t??e.components.badge.icon};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.content.disabled};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.content.disabled};
        }
    }
`,ue=He`
    ${Ue}

    /* layout */
    padding-inline: 0;
    width: fit-content;

    /* content */
    color: ${({theme:e})=>e.primary};

    /* appearance */
    background-color: ${({theme:e})=>e.components.badge.backgroundPressed};
    border-color: ${({theme:e})=>e.primary};

    svg.context-icon {
        fill: ${({theme:e})=>e.primary};
    }
`,ot=N.section`
    ${ue}

    /* reset */
    cursor: default;

    /* layout */
    gap: ${r[50]};
    padding-left: ${r[100]};

    svg {
        margin: -${r[25]};
        fill: ${({theme:e})=>e.components.badge.icon};
    }
`,ge=N(K.Root)`
    /* reset */
    ${h}

    /* layout */
    ${P}
    padding-inline: ${r[25]} ${r[100]};
    height: 100%;

    /* content */
    fill: ${({theme:e})=>e.components.badge.deleteIcon};

    /* appearance */
    background-color: ${({theme:e})=>e.surface.transparent.default};
    border-radius: 0 99px 99px 0;

    svg {
        margin: -${r[25]};
    }

    &:hover {
        background-color: ${({theme:e})=>e.components.badge.backgroundHover};
    }

    &:active {
        background-color: ${({theme:e})=>e.components.badge.backgroundActive};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.outline.focus} solid 2px;
    }
`,W=N.span`
    line-height: 1em;
    white-space: nowrap;
`,tt=({as:e,icon:t,defaultIconColor:n,onPress:c,onDelete:i,children:l,pressed:k,...u})=>{let x=e==="item"?K.Root:V.Item;return k?Ne(ot,{role:"radio","aria-checked":!0,children:[O(t,{className:"context-icon",color:"inherit"}),O(W,{children:l}),O(ge,{...u,as:x,onClick:i,"data-value":u.value,children:O(T,{className:"close-icon",color:"inherit"})})]}):Ne(me,{...u,as:x,onClick:()=>c(u.value),"data-value":u.value,$defaultIconColor:n,children:[O(t,{className:"context-icon",color:"inherit"}),O(W,{children:l})]})};import{useMemo as ct,useState as dt}from"react";import*as Qe from"@radix-ui/react-toggle-group";import*as Ye from"@radix-ui/react-toggle";import Ze from"styled-components";import"react";import{jsx as Fe}from"react/jsx-runtime";var rt=e=>Fe("svg",{xmlns:"http://www.w3.org/2000/svg",width:e?.width??24,height:e?.height??24,fill:e?.color??"#424242",viewBox:"0 0 24 24",...e,children:Fe("path",{fill:e?.color??"#424242",d:"M11.475 14.475 7.85 10.85a.47.47 0 0 1-.15-.35c0-.133.046-.25.138-.35.091-.1.212-.15.362-.15h7.6c.15 0 .271.05.363.15.091.1.137.217.137.35 0 .033-.05.15-.15.35l-3.625 3.625a.762.762 0 0 1-.25.175.735.735 0 0 1-.275.05.735.735 0 0 1-.275-.05.762.762 0 0 1-.25-.175"})}),be=rt;import{forwardRef as nt}from"react";import*as v from"@radix-ui/react-dropdown-menu";import qe,{css as at}from"styled-components";var X="0px 2px 4px 0px",Ve="-2px 0px 4px 0px",Ke="0px 2px 3px 0px";import{jsx as Xe}from"react/jsx-runtime";var it=qe(v.Content)`
    /* reset */
    outline: none;

    /* layout */
    min-width: 168px; // magic number from design
    padding-block: ${r[25]};
    margin-top: ${r[25]};

    /* content */
    ${p}

    /* appearance */
    background-color: ${({theme:e})=>e.surface.default};
    border: 1px solid ${({theme:e})=>e.outline.light};
    border-radius: ${d.small};
    box-shadow: ${({theme:e})=>`${X} ${e.shadow.menu}`};
`,he=at`
    /* reset */
    outline: none;
    cursor: pointer;
    box-sizing: border-box;

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    height: ${b.large};
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${s.innerGap};

    /* content */
    color: ${({$selected:e,theme:t})=>e?t.primary:t.onBackgroundSecondary};

    /* appearance */
    background-color: ${({theme:e})=>e.surface.transparent.default};

    &:focus-visible,
    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.surface.transparent.hover.neutralOnLight};
    }

    &:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.surface.transparent.active.neutralOnLight};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.content.disabled};
        cursor: not-allowed;
    }
`,fe=qe(v.Item)`
    ${he}
`,Je=v.Root,q=v.Trigger;var J=nt(({children:e,...t},n)=>Xe(v.Portal,{children:Xe(it,{...t,ref:n,children:e})}));J.displayName="Menu";import{jsx as f,jsxs as Q}from"react/jsx-runtime";var st=Ze.section`
    ${ue}
`,lt=Ze.button`
    /* reset */
    ${h}

    /* content */
    ${p}

    /* layout */
    ${P}
    gap: ${r[50]};
    padding-inline: ${r[100]} ${r[25]};
    height: 100%;

    svg {
        margin: -${r[25]};
        fill: ${({theme:e})=>e.components.badge.icon};
    }
`,pt=({as:e,defaultIconColor:t,disabled:n,icon:c,options:i,pressed:l,onDelete:k,onSelect:u,children:x,...B})=>{let[ie,I]=dt(!1),Po=S=>{I(!1),u(S)},wo=S=>{I(S)},To=ct(()=>i.find(S=>S.value===B.value),[i,B.value]),Re=e==="item"?Ye.Root:Qe.Item;return Q(Je,{open:ie,onOpenChange:wo,children:[l?Q(st,{role:"radio","aria-checked":!0,children:[f(q,{asChild:!0,children:Q(lt,{onClick:()=>I(!0),children:[f(c,{className:"context-icon",color:"inherit"}),f(W,{children:To?.label}),f(be,{className:"expand-icon",color:"inherit"})]})}),f(ge,{...B,as:Re,onClick:k,"data-value":B.value,children:f(T,{className:"close-icon",color:"inherit"})})]}):f(q,{asChild:!0,disabled:n,children:Q(me,{...B,as:Re,onClick:()=>I(!0),"data-value":B.value,$defaultIconColor:t,children:[f(c,{className:"context-icon",color:"inherit"}),f(W,{children:x}),f(be,{className:"expand-icon",color:"inherit"})]})}),f(J,{align:"start",children:i.map(S=>{let{value:ce,label:Co,isDisabled:So}=S,Ro=l&&B.value===ce;return f(fe,{id:ce,onSelect:Do=>Po(Do.target.id),$selected:Ro,disabled:So,children:Co},ce)})})]})};import ft from"styled-components";import ye,{keyframes as mt}from"styled-components";import{jsx as _e,jsxs as ht}from"react/jsx-runtime";var ut=mt`
    0% {
        transform: scale(0);
        opacity: 0;
    }
    33% {
        transform: scale(0.44);
        opacity: 1;
    }
    100% {
        transform: scale(0.88);
        opacity: 0;
    }
`,gt=ye.div.attrs({"aria-hidden":!0})`
    /* reset */
    // we leverage font-size to have the circles scale
    font-size: ${({size:e})=>e}rem;

    /* layout */
    width: ${({size:e})=>e}rem;
    height: ${({size:e})=>e}rem;
    position: relative;
`,je=ye.div`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: absolute;
    width: 100%;
    height: 100%;

    /* appearance */
    opacity: 0;
    border-radius: 50%;
    border: 0.125em solid ${({theme:e})=>e.primary};
    animation: ${ut} 1.3s ease-out infinite;
`,bt=ye(je)`
    /* appearance */
    border: 0.125em solid ${({theme:e})=>e.primary};
    animation-delay: 0.65s;
`,eo=({size:e=1.5})=>ht(gt,{size:e,children:[_e(je,{}),_e(bt,{})]});import{Fragment as xt,jsx as $e,jsxs as vt}from"react/jsx-runtime";var yt=ft(m)`
    /* reset */
    padding: 0;
    border: none;
    height: auto;

    /* layout */
    display: flex;
    gap: ${r[25]};

    /* content */
    color: ${({theme:e})=>e.primary};
    text-decoration: underline;
    text-underline-offset: ${r[25]};

    /* appearance */
    &[data-visited='true'] {
        color: ${({theme:e})=>e.components.link.visited};
    }
    &[data-hovered] {
        color: ${({theme:e})=>e.components.link.hover};
    }
    &[data-pressed] {
        color: ${({theme:e})=>e.components.link.active};
    }
    &[data-disabled] {
        color: ${({theme:e})=>e.content.disabled};
    }
`,$t=({icon:e,isDisabled:t,isLoading:n,isVisited:c,children:i,...l})=>$e(yt,{...l,isDisabled:n||t,"data-visited":c,$variant:"medium",children:vt(xt,{children:[function(){return n?$e(eo,{}):e?$e(e,{color:"currentColor"}):null}(),i]})});import Bt from"styled-components";var Y=Bt(m)`
    /* variants */
    background-color: ${({theme:e})=>e.surface.destructive.default};
    color: ${({theme:e})=>e.content.onPrimary};
    border-color: ${({theme:e})=>e.surface.destructive.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.surface.destructive.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.surface.destructive.active};
    }
    &[data-disabled] {
        background-color: ${({theme:e})=>e.surface.destructive.disabled};
        border-color: ${({theme:e})=>e.surface.destructive.disabled};
        color: ${({theme:e})=>e.content.disabledOnDestructive};
    }
`;import kt from"styled-components";var Z=kt(m)`
    /* variants */
    background-color: ${({theme:e})=>e.surface.primary.default};
    color: ${({theme:e})=>e.content.onPrimary};
    border-color: ${({theme:e})=>e.surface.primary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.surface.primary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.surface.primary.active};
    }
    &[data-disabled] {
        background-color: ${({theme:e})=>e.surface.transparent.default};
        color: ${({theme:e})=>e.content.disabled};
    }
`;import Pt from"styled-components";var oo=Pt(m)`
    /* variants */
    background-color: ${({theme:e})=>e.surface.neutral.default};
    color: ${({theme:e})=>e.content.onNeutral};
    border-color: ${({theme:e})=>e.surface.neutral.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.surface.neutral.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.surface.neutral.active};
    }
    &[data-disabled] {
        background-color: ${({theme:e})=>e.surface.neutral.disabled};
        border-color: ${({theme:e})=>e.surface.neutral.disabled};
        color: ${({theme:e})=>e.content.disabled};
    }
`;import{jsx as xe}from"react/jsx-runtime";var wt=({children:e,...t})=>xe(Z,{...t,$variant:"large",children:e}),Tt=({children:e,...t})=>xe(Y,{...t,$variant:"large",children:e}),Ct=({children:e,...t})=>xe(oo,{...t,$variant:"large",$fluid:!0,children:e});import ro from"styled-components";import*as y from"@radix-ui/react-dialog";import{jsx as to,jsxs as At}from"react/jsx-runtime";var St=ro(y.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.components.backdrop};
`,Rt=ro(y.Content)`
    /* reset */
    user-select: none;

    /* layout */
    position: fixed;
    bottom: 0;
    left: 0;
    height: auto;
    max-height: 60vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    /* appearance */
    background-color: ${({theme:e})=>e.surface.default};
    border-radius: ${d.large} ${d.large} 0 0;
    outline: none;
`,Dt=y.Root,It=y.Trigger,no=y.Title,ao=({children:e})=>At(y.Portal,{children:[to(St,{}),to(Rt,{children:e})]});import*as _ from"@radix-ui/react-checkbox";import so from"styled-components";import"react";import{jsx as io}from"react/jsx-runtime";var Mt=e=>io("svg",{xmlns:"http://www.w3.org/2000/svg",width:e?.width??24,height:e?.height??24,fill:e?.color??"#424242",viewBox:"0 0 24 24",...e,children:io("path",{fill:e?.color??"#424242",d:"m10.6 13.4-2.15-2.15a.948.948 0 0 0-.7-.275.948.948 0 0 0-.7.275.948.948 0 0 0-.275.7c0 .283.092.517.275.7L9.9 15.5c.2.2.433.3.7.3.267 0 .5-.1.7-.3l5.65-5.65a.948.948 0 0 0 .275-.7.948.948 0 0 0-.275-.7.948.948 0 0 0-.7-.275.948.948 0 0 0-.7.275zM5 21c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.804 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21z"})}),co=Mt;import{jsx as ve,jsxs as zt}from"react/jsx-runtime";var Et=so.label`
    /* reset */
    cursor: pointer;
    user-select: none;

    /* content */
    ${p}

    /* layout */
    display: flex;
    align-items: center;
    gap: 0.5em;

    /* appearance */
    &:has(button[data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.content.disabled};
    }

    &&&:hover:not(:has(button[data-disabled])) {
        color: ${({theme:e})=>e.components.label.hover};
    }

    &&&:active:not(:has(button[data-disabled])) {
        color: ${({theme:e})=>e.components.label.active};
    }
`,Ot=so(_.Root)`
    /* reset */
    ${h}
    position: relative;

    /* layout */
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;

    /* appearance */
    color: ${({theme:e})=>e.components.checkbox.icon};
    &[data-disabled] {
        cursor: not-allowed;
        color: ${({theme:e})=>e.content.disabled};
    }

    // adding a symbol for unchecked state
    &:after {
        /* reset */
        content: '';
        box-sizing: border-box;

        /* layout */
        top: 0.25rem;
        left: 0.25rem;
        position: absolute;
        width: 1rem;
        height: 1rem;

        /* appearance */
        border-radius: 1px;
        outline-width: 2px;
        // we need one pixel on either side of the outline
        outline-offset: -1px;
        outline-style: solid;
        outline-color: inherit;
    }
`,Wt=({name:e,children:t,...n})=>zt(Et,{htmlFor:e,children:[ve(Ot,{...n,name:e,children:ve(_.Indicator,{children:ve(co,{color:"currentColor"})})}),t]});import lo from"styled-components";import*as j from"@radix-ui/react-toggle-group";import{jsx as Be,jsxs as po}from"react/jsx-runtime";var Lt=lo(no)`
    /* reset */
    cursor: default;
    font-weight: normal;
    font-style: normal;
    font-size: 1rem;
    margin: 0;

    /* content */
    ${de}
    color: ${({theme:e})=>e.components.note};

    /* layout */
    height: ${b.large};
    display: flex;
    align-items: center;
    padding-inline: ${s.horizontalComponentGap};
`,Gt=lo(j.Item)`
    /* reset */
    ${he}
    border: none;

    /* content */
    ${p}
    color: ${({theme:e})=>e.onBackgroundSecondary};
    &[data-state='on'] {
        color: ${({theme:e})=>e.primary};
    }
`,Nt=({title:e,children:t,...n})=>po(ao,{children:[Be(Lt,{children:e}),Be(j.Root,{type:"single",...n,children:t})]}),Ht=({icon:e,children:t,...n})=>po(Gt,{...n,children:[Be(e,{color:"currentcolor"}),t]});import ke from"styled-components";import Ft from"styled-components";import Ut from"styled-components";var ee=Ut(m)`
    /* variants */
    background-color: ${({theme:e})=>e.surface.transparent.default};
    color: ${({theme:e})=>e.components.embeddedBtn.onBackground};
    border-color: ${({theme:e})=>e.surface.transparent.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.components.embeddedBtn.backgroundHovered};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.components.embeddedBtn.backgroundPressed};
    }
    &[data-disabled] {
        background-color: ${({theme:e})=>e.surface.transparent.default};
        color: ${({theme:e})=>e.content.disabled};
    }
`;import{jsx as mo}from"react/jsx-runtime";var Vt=Ft(ee).attrs({$variant:"small"})`
    /* layout */
    padding-inline: 0;
    justify-content: center;

    /* content */
    color: ${({$color:e,theme:t})=>e??t.actionIcon};

    width: ${({$variant:e})=>E(e)};
`,oe=({icon:e,color:t,...n})=>mo(Vt,{$color:t,...n,children:mo(e,{color:"currentcolor"})});import{jsx as uo,jsxs as go}from"react/jsx-runtime";var Kt="360px",Xt="56px",qt=ke.aside`
    /* layout */
    width: ${Kt};
    height: 100vh;
    display: flex;
    flex-direction: column;

    /* appearance */
    background-color: ${({theme:e})=>e.surface.default};
    box-shadow: ${Ve} ${({theme:e})=>e.shadow.menu};

    // take the whole screen in mobile views
    @media (max-width: ${$.small}) {
        width: 100vw;
    }
`,Jt=ke.header`
    /* reset */
    box-sizing: border-box;

    /* layout */
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: ${Xt};
    border-bottom: 1px solid ${({theme:e})=>e.outline.light};
    padding-inline: ${r[100]} ${r[75]};
`,Qt=ke.dl`
    /* reset */
    margin: 0;

    /* layout */
    padding: ${r[150]} ${r[75]};
    overflow: auto;

    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${r[150]};
`,Yt=({title:e,onClose:t,children:n,...c})=>go(qt,{...c,children:[go(Jt,{children:[e,uo(oe,{onPress:t,icon:T})]}),uo(Qt,{children:n})]});import Pe,{useTheme as Zt}from"styled-components";import{jsx as te,jsxs as tr}from"react/jsx-runtime";var _t=Pe.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-flow: row;
    align-items: center;
    column-gap: ${r[75]};
    row-gap: ${r[25]};
`,jt=Pe.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    /* content */
    ${We}
`,er=Pe.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    > *:not(:first-child)::before {
        content: '•';
        margin-inline: ${r[50]};
    }

    /* content */
    ${Oe}
    color: ${({theme:e})=>e.onBackgroundSecondary};
`,or=({icon:e,mainText:t,subTexts:n=[]})=>{let c=Zt(),i=!!t;return tr(_t,{children:[te(e,{color:c.icon}),i&&te(jt,{children:t}),te(er,{children:n.map(l=>te("span",{children:l},l))})]})};import rr from"styled-components";var nr=rr.section`
    width: 640px;
    background-color: ${({theme:e})=>e.surface.default};
    border-radius: ${d.small};
    box-sizing: border-box;
    padding: 1rem;
    padding-bottom: 2rem;

    margin-top: 2rem;
    height: fit-content;

    @media (max-width: ${$.small}) {
        /* layout */
        margin: 1rem;
    }
`;import D from"styled-components";import*as g from"@radix-ui/react-dialog";import ar from"styled-components";var bo=ar(m)`
    /* variants */
    background-color: ${({theme:e})=>e.surface.transparent.default};
    color: ${({theme:e})=>e.primary};
    border-color: ${({theme:e})=>e.surface.primary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.surface.transparent.hover.primary};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.surface.transparent.active.primary};
    }
    &[data-disabled] {
        border-color: ${({theme:e})=>e.content.disabled};
        background-color: ${({theme:e})=>e.surface.transparent.default};
        color: ${({theme:e})=>e.content.disabled};
    }
`;import{jsx as C,jsxs as we}from"react/jsx-runtime";var ir=D(g.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.components.backdrop};
`,cr=D(g.Content)`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 512px;
    padding: ${r[200]};
    display: flex;
    flex-direction: column;
    gap: ${r[200]};

    /* appearance */
    background-color: ${({theme:e})=>e.surface.default};
    border-radius: ${d.small};
    outline: none;

    @media (max-width: ${$.small}) {
        /* layout */
        // in small screens we leave 1rem on each side
        width: calc(100% - ${r[200]});
    }
`,dr=D.section`
    /* layout */
    display: flex;
    justify-content: space-between;
    align-items: center;
`,sr=D.section`
    /* layout */
    display: flex;
    justify-content: flex-end;
    gap: ${s.horizontalComponentGap};

    @media (max-width: ${$.small}) {
        /* layout */
        flex-direction: column-reverse;
    }
`,lr=g.Root,pr=g.Trigger,mr=({actions:e,title:t,children:n,...c})=>(e.forEach(i=>{if(i.type!==ho)throw new Error("Invalid button type given to PromptContent actions")}),we(g.Portal,{children:[C(ir,{}),we(cr,{...c,children:[we(dr,{children:[C(M.SectionHeader,{children:t}),C(g.DialogClose,{asChild:!0,children:C(oe,{icon:T})})]}),n,C(sr,{children:e.map(i=>i)})]})]})),ur=D(Z).attrs({$variant:"large"})`
    /* layout */
    ${U}
`,gr=D(bo).attrs({$variant:"large"})`
    /* layout */
    ${U}
`,br=D(Y).attrs({$variant:"large"})`
    /* layout */
    ${U}
`,ho=({closeOnSubmit:e=!0,variant:t,children:n,...c})=>{let i=(()=>{switch(t){case"primary":return ur;case"secondary":return gr;case"destructive":return br}})();return e?C(g.DialogClose,{asChild:!0,children:C(i,{...c,children:n})}):C(i,{...c,children:n})};import*as re from"@radix-ui/react-switch";import Te from"styled-components";import{jsx as fo,jsxs as xr}from"react/jsx-runtime";var hr=Te(re.Root)`
    /* reset */
    transition: background-color 0.3s;
    border: none;
    cursor: pointer;

    /* layout */
    position: relative;
    width: 2.25rem;
    height: 1rem;

    /* appearance */
    background-color: ${({theme:e})=>e.components.toggle.track.unchecked};
    border-radius: ${d.round};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.components.toggle.track.checked};
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.components.toggle.track.disabledUnchecked};
    }
    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.components.toggle.track.disabledChecked};
    }

    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.components.toggle.track.hoverUnchecked};
        span {
            background-color: ${({theme:e})=>e.components.toggle.thumb.hoverUnchecked};
        }

        &[data-state='checked'] {
            background-color: ${({theme:e})=>e.components.toggle.track.hoverChecked};
            span {
                background-color: ${({theme:e})=>e.components.toggle.thumb.hoverChecked};
            }
        }
    }
`,fr=Te(re.Thumb)`
    /* reset */
    transition-property: transform, background-color;
    transition-duration: 0.3s;
    will-change: transform;

    /* layout */
    position: absolute;
    top: -0.125rem; // (track height - thumb height) / 2
    left: 0;
    width: 1.25rem;
    height: 1.25rem;
    transform: translateX(-0.5rem);

    /* appearance */
    background-color: ${({theme:e})=>e.components.toggle.thumb.unchecked};
    border-radius: ${d.round};
    box-shadow: ${Ke} ${({theme:e})=>e.shadow.element};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.components.toggle.thumb.checked};
        transform: translateX(1.25rem);
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.components.toggle.thumb.disabledUnchecked};
    }

    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.components.toggle.thumb.disabledChecked};
    }
`,yr=Te.label`
    /* reset */
    cursor: pointer;
    user-select: none;
    transition: color 0.3s;

    /* content */
    ${p}

    /* layout */
    display: flex;
    align-items: center;
    gap: 1rem;

    /* appearance */
    &:has([data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.content.disabled};
    }

    &:hover:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.components.label.hover};
    }

    &:active:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.components.label.active};
    }
`,$r=({children:e,name:t,...n})=>xr(yr,{htmlFor:t,children:[fo(hr,{...n,name:t,children:fo(fr,{})}),e]});import*as ne from"@radix-ui/react-tooltip";import Ce from"styled-components";import vr from"styled-components";var yo=vr(ee)`
    /* variants */
    color: ${({theme:e})=>e.primary};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.surface.transparent.hover.primary};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.surface.transparent.active.primary};
    }
`;var $o=Ce(ne.Content)`
    /* layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    max-width: 400px;
    padding: ${r[25]};

    /* content */
    ${p}
    color: ${({theme:e})=>e.content.onNeutral};

    /* appearance */
    background-color: ${({theme:e})=>e.surface.neutral.default};
    border-radius: ${d.small};
    outline: none;
    box-shadow: ${({theme:e})=>`${X} ${e.shadow.menu}`};

    @media (max-width: ${$.small}) {
        /* layout */
        max-width: calc(100vw - 2 * ${r[100]});
        flex-direction: column;
    }
`,xo=Ce.p`
    margin: 0;
    padding: ${r[25]} ${r[50]};
`,vo=Ce(yo).attrs({$variant:"small"})`
    align-self: end;
`,Br=ne.Provider;import kr from"styled-components";import*as z from"@radix-ui/react-tooltip";import{useState as Pr}from"react";import{jsx as ae,jsxs as Bo}from"react/jsx-runtime";var wr=kr(z.Trigger)`
    padding: 0;
    border: 0;
    background-color: transparent;
`;function Tr({children:e,description:t,actionButtonText:n,onActionButtonClick:c,openDelay:i=500,...l}){let[k,u]=Pr(!1);return Bo(z.Root,{delayDuration:i,open:k,onOpenChange:u,children:[ae(wr,{onClick:()=>u(x=>!x),onFocus:()=>setTimeout(()=>u(!0),0),onBlur:x=>x.preventDefault(),children:e}),ae(z.Portal,{children:Bo($o,{side:"bottom",sideOffset:4,...l,children:[ae(xo,{children:t}),ae(vo,{onPress:c,children:n})]})})]})}import ko from"styled-components";import{jsx as Se}from"react/jsx-runtime";var Cr=ko.span`
    /* reset */
    ${h}

    /* layout */
    ${P}
    padding-inline: 0;
    justify-content: center;

    /* appearance */
    ${L}
    width: ${E("small")};
    height: ${E("small")};

    background-color: transparent;
    color: ${({theme:e})=>e.components.embeddedBtn.onBackgroundOnDarkSurface};
    border-color: transparent;
`,Sr=ko(m).attrs({$variant:"medium"})`
    background: transparent;
    padding: 0 ${r[75]}

    border-radius: 0;
    border-width: 0;
    border-style: none;

    width: ${({$width:e})=>e};
    height: ${({$height:e})=>e};

    ${({$iconPosition:e})=>{switch(e){case"left":return"justify-content: flex-start;";case"right":return"justify-content: flex-end;"}}}

    &[data-hovered] .iconWrapper {
        background-color: ${({theme:e})=>e.components.embeddedBtn.backgroundHoveredOnDarkSurface};
    }
    &[data-pressed] .iconWrapper {
        background-color: ${({theme:e})=>e.components.embeddedBtn.backgroundPressedOnDarkSurface};
    }
    &[data-disabled] .iconWrapper {
        cursor: not-allowed;
        color: ${({theme:e})=>e.content.disabled};
    }
`,Rr=({icon:e,width:t,height:n,iconPosition:c,...i})=>Se(Sr,{...i,$width:t,$height:n,$iconPosition:c,children:Se(Cr,{className:"iconWrapper",children:Se(e,{color:"currentColor"})})});export{Qo as Accordion,_o as AccordionItem,Tr as ActionableTooltip,tt as Badge,et as BadgeGroup,pt as BadgeSelect,W as BadgeText,Dt as BottomSheet,It as BottomSheetTrigger,Wt as Checkbox,Nt as ChoiceDrawer,Ht as ChoiceDrawerItem,Rr as EmbeddedAreaIconOnDarkSurfaceButton,or as FileInfoEntry,$t as LinkButton,J as Menu,fe as MenuItem,q as MenuTrigger,nr as PageCard,Ct as PageNeutralButton,wt as PagePrimaryButton,Tt as PagePrimaryDestructiveButton,lr as Prompt,ho as PromptActionButton,mr as PromptContent,pr as PromptTrigger,Yt as SideDrawer,$r as Toggle,Br as TooltipProvider,M as Typography,Ao as lightTheme};
//# sourceMappingURL=index.mjs.map